import React, { PureComponent } from 'react';
import { Formik } from 'formik';
import { Trans, withTranslation } from 'react-i18next';
import { PageView } from '@jg/react-tracking';
import Alert from '@jg/alert';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import {
  ICreateTeamComponentDispatchToProps,
  ICreateTeamComponentMapStateToProps,
  TCreateTeam,
  ICreateTeamFormProps,
} from './CreateTeam.d';
import {
  getRequestIsInFlight,
  getRequestIsError,
} from '../../selectors/loadingSelectors';
import { IAppState } from '../../types/state.d';
import { REQUEST } from '../../consts';
import CreateTeamForm from '../../components/CreateTeamForm';
import StepNavigation from '../../components/StepNavigation';
import { getTeamName } from '../../selectors/apiSelectors';
import submitTeamName from '../../actions/thunks/submitTeamName';

// TODO Rename to teamName
export class CreateTeam extends PureComponent<TCreateTeam> {
  render() {
    const { t, isInFlight, isError, teamName } = this.props;
    return (
      <PageView
        trackingData={{
          subtype: 'page creation',
          event_value: 'create a team',
          page_section: 'page creation > create a team',
        }}
      >
        <Helmet title={t('title.createTeam')} />
        <main>
          <StepNavigation currentStep={1} />
          <h1>
            <Trans data-qa="heading" i18nKey="content.createteam.heading" />
          </h1>
          <p className="jg-text--large jg-space-mbml">
            <Trans data-qa="subtext" i18nKey="content.createteam.subtext" />
          </p>
          <Formik<ICreateTeamFormProps>
            initialValues={{
              teamName,
            }}
            validationSchema={Yup.object().shape({
              teamName: Yup.string()
                .max(100, t('content.createteam.name.maxcharacters'))
                .required(t('content.createteam.name.required')),
            })}
            onSubmit={this.props.submitTeamName}
            render={
              /* istanbul ignore next */ formikProps => (
                <CreateTeamForm
                  isInFlight={isInFlight}
                  isError={isError}
                  {...formikProps}
                />
              )
            }
          />
          {isError && (
            <Alert
              type="warning"
              displayType="inline"
              className="jg-space-mbmd"
              data-qa="submit-team-name-error"
            >
              {t('global.error.fatal')}
            </Alert>
          )}
          <small className="jg-text--light jg-display-b jg-space-pbmd">
            <Trans data-qa="notice" i18nKey="content.createteam.notice">
              If your team members don&rsquo;t need their own fundraising pages,
              you can add their names to a single, shared fundraising page
              without creating a team.
            </Trans>
          </small>
        </main>
      </PageView>
    );
  }
}

export const mapStateToProps = (
  state: IAppState,
): ICreateTeamComponentMapStateToProps => ({
  isInFlight: getRequestIsInFlight(state, REQUEST.SUBMIT_TEAM_NAME),
  isError: getRequestIsError(state, REQUEST.SUBMIT_TEAM_NAME),
  teamName: getTeamName(state),
});

export const mapDispatchToProps: ICreateTeamComponentDispatchToProps = {
  submitTeamName,
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CreateTeam),
);
